import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {removeListingParams} from "../../listing-params";

export const SessionListingsPlugin = ({next}) => cs(
    consumeContext("company"),
    ["allListingSearch", ({company}, next) => next(company?.prefs?.allowUserLevelAllListingsSearch)],
    ["listingId", ({}, next) => next(sessionStorage.getItem('listingId'))],
    ["listingIdAgent", ({}, next) => next(sessionStorage.getItem('listingIdAgent'))],
    ({allListingSearch, listingIdAgent, listingId}) => next(
        !allListingSearch && listingIdAgent && listingId && {
            warning: "Listing will be removed if user is changed!",
            beforeEmulate: () => removeListingParams(),
        }
    ),
);
